<template>
  <div>
    <van-dialog v-model="DialogShow" :title="isAdd?'新增商机':'修改商机'" width="95%" style="height:80%" class="editClue" :beforeClose="beforeClose" show-cancel-button>
      <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-field readonly clickable v-model="form.custName" @click="isAdd?showCustList():''" label="客户" :rules="[{ required: true }]" placeholder="请选择客户" required/>
        <van-field readonly clickable v-model="form.businessTypeName" @click="showPicker2('businessType')" label="业务类型" :rules="[{ required: true }]" placeholder="请选择业务类型" required />
        <!-- <van-field readonly clickable v-model="form.industryName" @click="form.businessTypeName?showPicker2('industry'):''" label="行业分类" :rules="[{ required: true }]" placeholder="请选择行业分类/请先选择业务类型" required v-if="form.businessTypeName?form.businessTypeName.indexOf('品牌推广类') === -1 && form.businessTypeName.indexOf('数字技术类') === -1:false" /> -->
        <van-field readonly clickable v-model="form.possibilityName"  @click="showPicker('possibility')" label="意向度" placeholder="请选择意向度" required :rules="[{ required: true }]" />
        <van-field readonly clickable v-model="form.boStageIdName" @click="showPicker('boStageId')" label="商机阶段" placeholder="请选择商机阶段" required :rules="[{ required: true }]" />
      </van-form>
    </van-dialog>
    <!-- 日期选择器 -->
    <!-- <van-calendar v-model="showDate" :min-date="minDate" type="single" @confirm="dateConfirm" /> -->

    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
    <van-popup v-model="cascader.visible" position="bottom">
      <van-cascader :title="cascader.title" :options="cascader.treeList" :field-names="cascader.fieldNames" @change="serviceChange" @close="cascader.visible = false" @finish="onFinishTree" />
    </van-popup>
    <select-customer :show='select_show' @handleCancel='handleCancel' @beforeClose='selectBeforeClose'></select-customer>
  </div>
</template>
<script>
import { addBo, getAllStage, updateBo } from '@/api/scrm/mycust'
// import { getDicts } from '@/api/system/dict/data'
// import { getdistrict } from '@/api/system/district.js'
// businessTypeList
import { advIndustryPointList, selectAllAddBo } from '@/api/admi/dept'
import { Toast, Cascader } from 'vant'
import SelectCustomer from '@/components/common/SelectCustomer'
// import { getDicts } from '@/api/system/dict/data'

export default {
  name: 'DialogBo',
  components: {
    [Toast.name]: Toast,
    vanCascader: Cascader,
    SelectCustomer
  },
  props: {
    show: Boolean,
    isAdd: Boolean,
    // contractId: [Number, String],
    modifyObj: Object
  },
  watch: {
    show: {
      handler(val, oldVal) {
        this.DialogShow = val
      }
    },
    // contractId: {
    //   handler(val, oldVal) {
    //     this.id = val
    //   }
    // },
    isAdd: {
      handler(val, oldVal) {
        this.isAdd = val
      }
    },
    modifyObj: {
      handler(val, oldVal) {
        this.form = val
      }
    }
  },
  data() {
    return {
      DialogShow: this.show,
      select_show: false,
      cascader: {
        visible: false,
        type: '',
        title: '',
        treeList: [],
        fieldNames: {

        }
      },
      // showServiceTree: false,
      serviceTypeTreeList: [],
      industryList: [],
      // fieldNames: {
      //   text: 'businessTypeName',
      //   value: 'businessTypeId'
      // },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      options: {
        possibilityOptions: [],
        boStageIdOptions: []
      },
      form: this.modifyObj || {
        boId: null,
        boName: null,
        custId: '',
        custName: '',
        boSource: '',
        businessTypeId: '',
        businessTypeName: '',
        advIndustryPointId: '',
        industryName: '',
        possibility: '',
        possibilityName: '',
        boStageId: '',
        boStageIdName: ''
      }
    }
  },
  async created() {
    // 意向度
    await this.getDicts('crm_bo_possibility ').then(res => {
      this.options.possibilityOptions = res.data
    })
    await getAllStage().then(response => {
      this.options.boStageIdOptions = response.rows || []
    })
    if (!this.isAdd) {
      this.id = this.form.boId
      // this.getBoInfo(this.form.boId)
      this.setName('possibility')
      this.setName('boStageId')
    }
  },
  methods: {
    // formatHandel(type, value) {
    //   const options = type + 'Options'
    //   if (value || value == 0) {
    //     return this.selectDictLabel(this.options[options], value)
    //   } else {
    //     return ''
    //   }
    // },
    // async getBoInfo(boId) {
    //   const res = await getBo(boId)
    //   if (res.code === 200) {
    //     this.form = { ...this.form, ...res.data }
    //     // this.setName('distributeStatus')
    //     // this.setName('boStatus')
    //     // this.setName('boSource')
    //     this.setName('possibility')
    //     this.setName('boStageId')
    //     console.log(res.data)
    //     // if (this.form.quotedPriceList) {
    //     //   for (let i = 0; i < this.form.quotedPriceList.length; i++) {
    //     //     const element = this.form.quotedPriceList[i]
    //     //     element.unitName = element.unit == 1 ? '小时' : '天'
    //     //   }
    //     // }
    //   }
    // },
    setName(type) {
      const optionItem = type + 'Options'
      const obj = this.options[optionItem].find((item, index) => {
        if (type == 'boStageId') {
          return item.boStageId == this.form[type]
        } else {
          return item.dictValue == this.form[type]
        }
      })
      if (obj != null) {
        const name = type + 'Name'
        if (type == 'boStageId') {
          this.form[name] = obj.stageName + '(' + obj.stageValue + '%)'
        } else {
          this.form[name] = obj.dictLabel
        }
      }
    },
    async showPicker2(type) {
      this.cascader.type = type
      if (type === 'businessType') {
        this.cascader.fieldNames = {
          text: 'businessTypeName',
          value: 'businessTypeId'
        }
        if (this.serviceTypeTreeList.length == 0) {
        // 获取获取业务类型
          await selectAllAddBo().then((response) => {
            if (response.code === 200) {
              this.serviceTypeTreeList = this.handleTree(response.data, 'businessTypeId')
            }
          })
        }
        this.cascader.treeList = this.serviceTypeTreeList
      } else if (type === 'industry') {
        this.cascader.fieldNames = {
          text: 'industryName',
          value: 'advIndustryPointId'
        }
        await advIndustryPointList({ businessTypeId: this.form.businessTypeId, businessTypeName: this.form.businessTypeName.split('/')[this.form.businessTypeName.split('/').length - 1] }).then(res => {
          if (res.code == 200) {
            this.industryList = this.getData(res.rows, 'industry')
          }
        })
        this.cascader.treeList = this.industryList
      }

      this.cascader.visible = true
    },
    // 去除树形数据的空children
    removeEmptyChildren(node) {
      node.forEach(item => {
        if ('children' in item && item.children.length === 0) {
          delete item.children
        } else if ('children' in item && item.children.length) {
          this.removeEmptyChildren(item.children)
        }
      })
      return node
    },
    /** 转换业务类型数据结构 */
    getData (arr, type) {
      if (type === 'businessType') {
        // 利用两层filter实现
        const data = arr.filter(item => {
          item.children = arr.filter(e => {
            return item.businessTypeId === e.parentId
          })
          return !item.parentId
        })
        return this.removeEmptyChildren(data)
      } else if (type === 'industry') {
        // 利用两层filter实现
        const data = arr.filter(item => {
          item.children = arr.filter(e => {
            return item.advIndustryPointId === e.parentId
          })
          return !item.parentId
        })
        return this.removeEmptyChildren(data)
      }
    },
    showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type == 'boStageId') {
        this.picker.columns = this.options.boStageIdOptions.map(ele => this.boStageNormalizer(ele))
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      }

      this.picker.visible = true
    },
    boStageNormalizer(node) {
      return {
        id: node.boStageId,
        text: node.stageName + '(' + node.stageValue + '%)'
      }
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      if (this.index || this.index == 0) {
        this.form.quotedPriceList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
        this.form.quotedPriceList[this.index][name] = this.options[optionItem][key].dictLabel
      } else {
        if (this.picker.formKey == 'boStageId') {
          this.form[this.picker.formKey] = this.options[optionItem][key].boStageId
          this.form[name] = this.options[optionItem][key].stageName + '(' + this.options[optionItem][key].stageValue + '%)'
        } else {
          this.form[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form[name] = this.options[optionItem][key].dictLabel
        }
      }
      this.picker.visible = false
    },
    serviceChange(obj) {
      if (obj.selectedOptions[3]) {
        if (obj.selectedOptions[3].businessTypeName == '腾讯') {
          this.form.businessTypeId = obj.value
          this.form.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
          this.form.businessTypeName = '销售/' + this.form.businessTypeName
        }
      }
    },
    onFinishTree(obj) {
      if (this.cascader.type === 'businessType') {
        this.form.businessTypeId = obj.value
        this.form.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
        this.form.businessTypeName = '销售/' + this.form.businessTypeName
      } else if (this.cascader.type === 'industry') {
        this.form.advIndustryPointId = obj.value
        this.form.industryName = obj.selectedOptions.map((option) => option.industryName).join('/')
      }
      this.cascader.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    pickerChange() { },
    showCustList() {
      this.select_show = true
      // this.showCust = true
      // this.custlist = []
      // this.handleCustList()
    },
    handleCancel() {
      this.select_show = false
    },
    selectBeforeClose(val) {
      this.form.custId = val.custId
      this.form.custName = val.custName
      this.form.boSource = val.custSource
      // this.form.boSourceName = this.options.boSourceOptions.find(item => item.dictValue == val.custSource).dictLabel
      this.select_show = false
    },
    async beforeClose(type, done) {
      if (type === 'confirm') {
        if (this.isAdd) {
          try {
            await this.$refs.form.validate()
            this.form.boName = this.form.custName + '【' + this.form.businessTypeName + '】'
            await addBo(this.form)
              .then((res) => {
                Toast.success('新增商机成功')
                setTimeout(() => {
                  this.form = {}
                  this.$emit('beforeClose', res.data)
                }, 500)
              }).catch(() => {})
            done()
          } catch (err) {
            return done(false)
          }
          return done(false)
        } else {
          try {
            await this.$refs.form.validate()
            this.form.boName = this.form.custName + '【' + this.form.businessTypeName + '】'
            await updateBo(this.form)
            await this.reset()
              .then(() => {
                Toast.success('修改商机成功')
                setTimeout(() => {
                  this.$emit('beforeClose', '')
                }, 500)
              }).catch(() => {})
            done()
          } catch (err) {
            return done(false)
          }
          return done(false)
        }
      } else {
        done()
        this.$emit('handleAddBoCancel')
      }
    },
    // 清空表单
    async reset() {
      this.form = {
        boId: null,
        boName: null,
        custId: '',
        custName: '',
        boSource: '',
        businessTypeId: '',
        businessTypeName: '',
        possibility: '',
        possibilityName: '',
        boStageId: '',
        boStageIdName: ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.editClue /deep/.van-dialog__content {
  height: 80%;
}
.link{
  height: 80px;
  margin-bottom: 60px;
}
.pictureList{
  margin-left: 30px;
  margin-top: 10px;
}
</style>
